
import { MapImageOverlay, MapRouteGPXOverlay } from "./mapping"
import { Task } from "./task"
import { v4 as uuidv4 } from 'uuid'
import { activity_status } from "./task-status"

export type PathTestGroupCriteria = {
  stage: string
  buildingId: string
}

export class PathTestPointSeq {

  constructor(
    public id = uuidv4()
  ) {

  }

  startTime: string
  stopTime: string

  dialerSeqId: string
  userId?: string

  data: {
    timestamp?: string
    userId?: string
    callsPlaced?: number
    callsCompleted?: number
    hvac?: string
    doorOpenShutCount?: number
    footTraffic?: string
    att?: number
    verizon?: number
    tmobile?: number
    dish?: number
    issues?: string
    type?: string
  } = {}                        
}
export class PathTestPoint {
  id: string
  pointId?: string
  routeId?: string
  order: number
  statusId: number
  seqs: PathTestPointSeq[] = []

}
export class PathTest extends Task {

  static statusFromPoints( testPoints: PathTestPoint[]) {
    const statusIds = testPoints.map(testPoint=>testPoint.statusId)    
    let pathTestStatusId = activity_status.Id.NOT_STARTED
    if ( statusIds.length ) {
      if ( statusIds.every(id=>id==activity_status.Id.COMPLETE||id==activity_status.Id.NOT_USING) ){
        pathTestStatusId = statusIds.every(id=>id==activity_status.Id.NOT_USING) ? activity_status.Id.NOT_USING : activity_status.Id.COMPLETE
      } else if ( statusIds.some(id=>id==activity_status.Id.IN_PROGRESS||id==activity_status.Id.COMPLETE) ) {
        pathTestStatusId = activity_status.Id.IN_PROGRESS
      } else {
        pathTestStatusId = statusIds[0]
      }
    }
    return pathTestStatusId
  }

  order?: number
  testPoints : PathTestPoint[]
  overlay? : MapImageOverlay
  gpx? : MapRouteGPXOverlay
  constructor(){
    super()
  }

}

export type PathTestParticipant = {
  name: string
  title: string
  alias?: string
}